<template>
  <h6 class="fg-header" @click="$emit('open', filter.filterId)">
    {{ filter.title }}
  </h6>
  <div class="fg-body form-group">
    <div class="row">
      <div class="col">
        <span class="min-max">Min Price</span>
      </div>
      <!-- .col -->
      <div class="col text-right">
        <span class="min-max">Max Price</span>
      </div>
      <!-- .col -->
    </div>
    <!-- .row -->
    <div style="padding-left: 20px; padding-right: 20px; margin-bottom: 40px">
      <VueSlider
        v-model="range"
        :enable-cross="false"
        tooltip-placement="bottom"
        tooltip="always"
        :min="minPrice"
        :max="maxPrice"
        :lazy="true"
        ><template v-slot:tooltip="{ value }">
          <div class="custom-tooltip">${{ value }}</div>
        </template></VueSlider
      >
    </div>
  </div>
</template>

<script src="./ctrl-price-filter.js"></script>
